module.exports = __webpack_public_path__ + "img/logo.cbecba43.png";